import React from 'react';

function Navigation({ userData }) {
    return (
        userData && <>
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button">
                            <i className="fas fa-bars"></i>
                        </a>
                    </li>

                </ul>
                <h4 className='text-center' style={{ width: '90%', textTransform: 'uppercase', fontSize: '1.25rem' }}>
                    {userData?.role === "SUPERADMIN" && 'Himacool Cold Storage Device Management Portal - Master Admin DASHBOARD'}
                    {userData?.role === "CLIENT" && 'Himacool Cold Storage Device Management Portal - CUSTOMER DASHBOARD'}
                </h4>
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item d-none d-sm-inline-block">
                        <a href="#" className="nav-link" style={{ minWidth: 200, color: 'black', textAlign: 'right' }}>Hi, {userData?.name} </a>
                    </li>

                    {/* <li class="nav-item">
                        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
                            <i class="fas fa-expand-arrows-alt"></i>
                        </a>
                    </li> */}

                </ul>
            </nav>
        </>
    );
}

export default Navigation;